/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
// components
import BoxAddressSelected from './BoxAddressSelected';
import ValidationMessage from '../ValidationMessage/ValidationMessage';
// utils
import useImportScript from '../../../hooks/useImportScript';
import { isObject } from '../../../../domain/utils/utilitarios-frontend-coopeuch/object';
// styles
import { StyledLabel, StyledInput, StyledWrapperInputAutocomplete } from './styles';

let autoComplete;
let pressKeyDownUp = false;

const URL_GMAPS = process.env.REACT_APP_GMAPS_API;
const handleScriptLoad = (onSelectAddress, /* onBlurAddressInput, */ onPressEnter, autoCompleteRef) => {
  // COMMENT: Instancioamos el elemento autocompplete (el onChange del input es propio del componente de google)
  /* istanbul ignore next */
  autoComplete = new window.google.maps.places.Autocomplete(autoCompleteRef.current, {
    types: ['address'],
    componentRestrictions: { country: 'cl' },
    fields: ['geometry', 'address_components'],
  });

  // EVENTS
  /* google.maps.event.addDomListener(autoCompleteRef.current, 'blur', () => {
    onBlurAddressInput();
  }); */
  /* istanbul ignore next */
  google.maps.event.addDomListener(autoCompleteRef.current, 'keydown', (e) => {
    if (e.keyCode === 38 || e.keyCode === 40) {
      pressKeyDownUp = true;
    } else if (e.keyCode === 13) {
      // COMMENT: Si antes del enter, presiono las teclas direccionales arriba y abajo (se esta desplazando de la lista)
      // COMMENT: El enter es valido, se activa el evento PLACE_CHANGED y éste se encargará de la validacion de la direccion ingresada
      if (!pressKeyDownUp) {
        onPressEnter();
      }
    }
  });
  /* istanbul ignore next */
  autoComplete.addListener('place_changed', () => {
    const addressObject = autoComplete.getPlace() || {};
    let selectedAddress = {};
    // CUANDO SE TECLEA ENTER, aparte de entrar al handleKeyPres, tambien se entra a este handle, por lo que aquí validamos que vengan los objetos
    if (addressObject.address_components && addressObject.geometry) {
      const street = findAddressValueByField(addressObject.address_components, 'route');
      const numeration = findAddressValueByField(addressObject.address_components, 'street_number');
      const commune = findAddressValueByField(
        addressObject.address_components,
        'administrative_area_level_3'
      );
      const country = findAddressValueByField(addressObject.address_components, 'country');
      const latitude = addressObject.geometry.location.lat();
      const longitude = addressObject.geometry.location.lng();
      selectedAddress = {
        street: street.long_name || '',
        numeration: numeration.long_name || '',
        commune: commune.long_name || '',
        country: country.long_name || '',
        latitude: latitude || '',
        longitude: longitude || '',
      };
    }
    onSelectAddress(selectedAddress);
  });
};
/* istanbul ignore next */
const findAddressValueByField = (addressInfo = {}, field = '') => {
  const addressInfoArray = Object.values(addressInfo);

  const addressValues = addressInfoArray.find((addressInfoLitle) => {
    const isInArray = addressInfoLitle.types.some((type) => type === field);
    if (isInArray) return true;
    return false;
  });
  return addressValues || {};
};
/* istanbul ignore next */
const isObjectWithValues = (obj) => Object.values(obj).every((el) => el !== '') && isObject(obj);

const AddressInput = (props) => {
  const { label, onChange, coverage, onDoSomething , id} = props;

  const { isLoaded: isGmapsLoaded } = useImportScript({ url: URL_GMAPS });
  const [selectedAddress, setSelectedAddress] = useState({});
  const [isValidAddress, setIsValidAddress] = useState(null);
  const [isSelectedOne, setIsSelectedOne] = useState(null);
  const [validationMessage, setValidationMessage] = useState({
    visible: true,
    type: 'helper',
    text: 'Ingresa tu dirección con calle y número, luego selecciónala de la lista.',
  });

  const autoCompleteRef = useRef(null);
  /* istanbul ignore next */
  useEffect(() => {
    if (isGmapsLoaded)
      handleScriptLoad(
        (e) => handleSelectAddress(e),
        (e) => handlePressEnter(e),
        autoCompleteRef
      );
  }, [isGmapsLoaded]);
  /* istanbul ignore next */
  useEffect(() => {
    if (Object.keys(selectedAddress).length > 0) {
      onChange({ ...selectedAddress });
    }
  }, [selectedAddress]);
  /* istanbul ignore next */
  useEffect(() => {
     if (coverage && isValidAddress && isSelectedOne && id ===2 ) {
      if (coverage.value === false || coverage.code === 7 || id ===2) {
        setValidationMessage({
          visible: true,
          type: 'error',
          text: 'La dirección ingresada no tiene cobertura',
        });
      } else if (coverage.value === true)
        setValidationMessage({ visible: false, type: 'info', text: '' });
    } 
  }, [coverage]);
  /* istanbul ignore next */
  const handleSelectAddress = (selectedAddressParam) => {
    if (Object.keys(selectedAddressParam).length) {
      const isValid = isObjectWithValues(selectedAddressParam);

      if (isValid) {
        setValidationMessage({ visible: false, type: 'info', text: '' });
        setIsValidAddress(isValid);
        setIsSelectedOne(true);
        setSelectedAddress({ ...selectedAddressParam });
      } else {
        setValidationMessage({
          visible: true,
          type: 'error',
          text: 'La dirección ingresada debe tener calle, número, comuna y país',
        });
       onDoSomething();
      }
    } else onDoSomething();
  };

  /* istanbul ignore next */
  const handlePressEnter = (autoCompleteParam) => {
    const addressObj = autoCompleteParam?.getPlace() || {};
    // COMMENT: para el caso que se presione directamente enter sin elegir opciones con teclas direccionales
    // COMMENT: addres object viene con: {} ó {name: '....'} si no es primera vez escribe en el campo
    // COMMENT: si presiona enter cuando esta desplazandose en la lista, no se llega a este handle
    // COMMENT: cuando se sierra el boxAddressAndOnBlur y se presiona enter, ya no se ingresa a este handle, supongo que place_changed se encarga de validar
    if (Object.keys(addressObj).length === 0 || Object.keys(addressObj).length === 1)
      // TODO: Verificar si esta condición esta obsoleta
      onDoSomething();
  };
  /* istanbul ignore next */
  const handleOnCloseBoxAddressAndOnBlur = () => {
    setSelectedAddress({});
    setIsSelectedOne(false);
    setIsValidAddress(false);
    setValidationMessage({
      visible: true,
      type: 'error',
      text: 'Ingresa tu dirección con calle y número, luego selecciónala de la lista.',
    });
  };
  /* istanbul ignore next */
  const handleOnBlurInputAddress = () => {
    // COMMENT: El onBlur del componente de google no permite obviar el paso donde no se selecciona una direccion, por lo que usamos el onBlur del input
    /* istanbul ignore next */
    if (!isValidAddress) {
      setValidationMessage({
        visible: true,
        type: 'error',
        text: 'Ingresa tu dirección con calle y número, luego selecciónala de la lista.',
      });
    }
  }

  return (
    <div className="search-location-input">
      <StyledLabel>{label}</StyledLabel>
      {isValidAddress && (
        <BoxAddressSelected
          selectedAddress={selectedAddress}
          onClose={handleOnCloseBoxAddressAndOnBlur}
        />
      )}
      <StyledWrapperInputAutocomplete visible={!isValidAddress}>
        <StyledInput
          onBlur={() =>  handleOnBlurInputAddress()}
          ref={autoCompleteRef}
          placeholder="Ejemplo: Las gardenias 1156 La Florida, Chile"
          // onBlur={(event) => onBlurSelectAddress(event.target.value)}
          autoComplete="new-password"
        />
      </StyledWrapperInputAutocomplete>
      {validationMessage.visible ? (
        <ValidationMessage
          customStyles="margin-top: 4px;"
          type={validationMessage.type}
          message={validationMessage.text}
        />
      ) : (
        <div className="d-none d-md-block pb-1">&nbsp;</div>
      )}
    </div>
  );
};
/* istanbul ignore next */
AddressInput.defaultProps = {
  label: '',
  /* value: {
    street: '',
    numeration: '',
    commune: '',
    country: '',
    anotherData: '',
  }, */
  coverage: {
    value: null,
    code:null
  },
  id:0,
  onChange: () => null,
};

AddressInput.propTypes = {
  label: PropTypes.string,
  /* value: PropTypes.exact({
    street: PropTypes.string,
    numeration: PropTypes.string,
    commune: PropTypes.string,
    country: PropTypes.string,
    anotherData: PropTypes.string,
  }), */
  coverage: PropTypes.shape({
    value: PropTypes.bool,
    code:PropTypes.string
  }),
  onChange: PropTypes.func,
  id:PropTypes.number
};

export default AddressInput;
